

export const RenderHtml3 = props => {
  let { state: { content: __html }, dom, flow } = props;
  return <pre id="prevs" style={{ lineHeight: '1.5', whiteSpace: 'pre-wrap', wordWrap: 'break-word', overflow: 'hidden', width: flow, fontFamily: `SourseHanSansCN-Regular,Metrosant-Regular,SourseHanSansCN-Medium,SourceHanSansCN-Bold,SourceHanSansCN-Heavy,SourceHanSansCN-Light,SourceHanSansCN-Normal,SourceHanSansCN-ExtraLight` }}   >
    <div className="braft-output-content" style={{ width: '100%', }} ref={dom} dangerouslySetInnerHTML={{ __html }}></div>
  </pre>
}